import { useState } from 'react'
import SearchableSelect from '../../../components/ui/SearchableSelect'
import { creditFormEnum } from '../../../model/enum'
import { Ufs } from '../../../data/ufs';
import { Banks } from '../../../data/banks';
import { InputNumber } from '../../../components/ui/Input';
import { Button } from '../../../components/ui/Button';
import Title from '../../../components/ui/Title';

const BankDetails = ({ bankDetailsForm, onBack }) => {

    const {
        creditForm, setCreditForm,
        typeAccount, setTypeAccount,
        ufAccount, setUfAccount,
        bankDetails, setBankDetails,
        errosForm, onSendProposal
    } = bankDetailsForm;

    const onChangeBankDetails = (key, value) => setBankDetails({ ...bankDetails, [key]: value })

    return (
        <div style={{ marginBottom: '200px' }}>
            <Title
                text1={'Informações'}
                text2={'Bancárias'}
            />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                <div>
                    <SearchableSelect
                        className={'w-full'}
                        value={creditForm}
                        onChange={value => setCreditForm(value)}
                        options={[
                            { value: creditFormEnum.BMGAccount.id, label: creditFormEnum.BMGAccount.name },
                            { value: creditFormEnum.bankTransfer.id, label: creditFormEnum.bankTransfer.name },
                        ]}
                        label='Tipo de depósito'
                    />
                    {errosForm['creditForm'] && <span className='text-red-500'>{errosForm['creditForm']}</span>}
                </div>
                <div className="">
                    <SearchableSelect
                        className={'w-full'}
                        value={typeAccount}
                        onChange={value => setTypeAccount(value)}
                        options={[
                            { value: 1, label: 'Conta Corrente' },
                            { value: 2, label: 'Conta Poupança' },
                        ]}
                        label='Tipo de conta'
                    />
                    {errosForm['typeAccount'] && <span className='text-red-500'>{errosForm['typeAccount']}</span>}
                </div>
                <div>
                    <SearchableSelect
                        className={'w-full'}
                        value={ufAccount}
                        onChange={value => setUfAccount(value)}
                        options={Ufs.map(uf => ({ value: uf.uf, label: uf.name }))}
                        label='Uf da conta'
                    />
                    {errosForm['ufAccount'] && <span className='text-red-500'>{errosForm['ufAccount']}</span>}
                </div>
            </div>
            {creditForm == creditFormEnum.bankTransfer.id && <div className='mt-5'>
                <Title
                    text1={'Dados'}
                    text2={'Bancários'}
                />
                <div className='gap-3 grid grid-cols-1 md:grid-cols-2'>
                    <div className="">
                        <SearchableSelect
                            className={'w-full'}
                            value={bankDetails.bankNumber}
                            onChange={value => onChangeBankDetails('bankNumber', value)}
                            options={Banks.map(bank => ({ value: bank.number, label: bank.name }))}
                            label='Banco'
                        />
                        {errosForm['bankNumber'] && <span className='text-red-500'>{errosForm['bankNumber']}</span>}
                    </div>
                    <div className='gap-3 grid grid-cols-2 md:grid-cols-2'>
                        <div>
                            <InputNumber
                                label='N° Agência'
                                value={bankDetails.numberAgency}
                                onChange={e => onChangeBankDetails('numberAgency', e.target.value)}
                            />
                            {errosForm['numberAgency'] && <span className='text-red-500'>{errosForm['numberAgency']}</span>}
                        </div>
                        <div>
                            <InputNumber
                                maxLength={2}
                                label='Dígito Agência'
                                value={bankDetails.agencyDigit}
                                onChange={e => onChangeBankDetails('agencyDigit', e.target.value)}
                            />
                            {errosForm['agencyDigit'] && <span className='text-red-500'>{errosForm['agencyDigit']}</span>}
                        </div>
                    </div>
                </div>
                <div className="gap-3 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3">
                    <div>
                        <InputNumber
                            label='N° Conta'
                            value={bankDetails.accountNumber}
                            onChange={e => onChangeBankDetails('accountNumber', e.target.value)}
                        />
                        {errosForm['accountNumber'] && <span className='text-red-500'>{errosForm['accountNumber']}</span>}
                    </div>
                    <div>
                        <InputNumber
                            maxLength={2}
                            label='Dígito Conta'
                            value={bankDetails.accountDigit}
                            onChange={e => onChangeBankDetails('accountDigit', e.target.value)}
                        />
                        {errosForm['accountDigit'] && <span className='text-red-500'>{errosForm['accountDigit']}</span>}
                    </div>
                </div>
            </div>
            }
            {!onBack && <div className="flex items-center justify-center sm:justify-end">
                <div className="w-full md:w-1/5">
                    <Button
                        onClick={onSendProposal}
                        className='w-full mt-3 rouded-sm'
                    >Enviar</Button>
                </div>
            </div>}
            {onBack && <div className="mt-5 flex items-center justify-between">
                <Button variant='outline' onClick={onBack}>Voltar</Button>
                <Button onClick={onSendProposal}>Enviar</Button>
            </div>}
        </div>
    )
}

export default BankDetails


// formaCredito
// id   name
// 2	Transferência Bancária
// 18	Conta BMG

//     "tipoDomicilioBancario": 1, // conta corrente = 1 | poupança = 2
//     "ufContaBeneficio": "SP" , // ufContaBeneficio

//     "bancoNumero": 237, // data.banks
//     "agenciaNumero": "1234", // numero da conta
//     "agenciaDV": "5", // digito agencia
//      contaNumero // numero da conta
//     "contaDV": "1", //digito conta
//     "tipoConta"1, // conta corrente = 1 | poupança = 2
